export function findClosestLanguage(target: string, languages: string[]): string | undefined {
  const exactMatch = languages.find((lang) => lang === target);

  if (exactMatch) return exactMatch;

  const mainLang = target.split('_')?.at(0);
  const parcialMatch = languages.find((lang) => lang === mainLang);

  return parcialMatch;
}
